import React, {useEffect, useState} from "react";
import AssociationBattleLoader from "./AssociationBattleLoader";
import {AssociationBattleProps} from "./types";
import {I18nextProvider} from "react-i18next";
import i18n from '@apps/Shared/translation/i18n';
import {getLocale} from "@apps/Shared/Utils/Utils";
import {
    useAssociationBattleBlockQuery,
    useGetStartPageModelQuery
} from "@apps/Shared/GraphQL/generated";

function App(): JSX.Element {
    const hiddenInput = document.querySelector('.js-association-battle');
    const id = Number((hiddenInput as HTMLInputElement).value);
    const locale = getLocale();

    const [associationBattleBlockItem, setAssociationBattleBlockItem] = useState<any>(null);
    const [googleMapsApiKey, setGoogleMapsApiKey] = useState<any>(null);

    const {data: associationBattleData} = useAssociationBattleBlockQuery({
        id: id,
        locale: [locale]
    });

    const {data: startPageData} = useGetStartPageModelQuery({
        locale: [locale]
    });

    useEffect(() => {
        if (associationBattleData?.Content?.items?.[0]) {
            setAssociationBattleBlockItem(associationBattleData.Content.items[0]);
        }
    }, [associationBattleData]);

    useEffect(() => {
        if (startPageData?.StartPageModel?.items?.[0]) {
            setGoogleMapsApiKey(startPageData.StartPageModel.items[0].MapsApiKey);
        }
    }, [startPageData]);

    if (associationBattleBlockItem && googleMapsApiKey) {
        const props: AssociationBattleProps = {
            heading: associationBattleBlockItem.Heading,
            googleMapsApiKey: googleMapsApiKey,
            wideLayout: associationBattleBlockItem.WideLayout,
            image: {
                type: "image",
                path: associationBattleBlockItem.Image?.RelativePath,
                altText: associationBattleBlockItem.Image?.Expanded?.AltText,
                name: associationBattleBlockItem.Image?.Name
            }
        };
        return (
            <I18nextProvider i18n={i18n}>
                <AssociationBattleLoader {...props} />
            </I18nextProvider>
        );
    } else {
        return (<> </>);
    }
}

export default App;